import SocialMedia from "./components/SocialMedia";

export default SocialMedia;
